
import { useStore } from "@/store";
import { Station } from "@/types";
import { computed, defineComponent, ref } from "vue";

export default defineComponent({
  setup() {
    const store = useStore();
    const stationList = computed(() => store.state.stationList);
    const newStationName = ref("");
    const addStation = () => {
      store.dispatch(
        "updateStationList",
        stationList.value.stations.concat({
          id: Math.max(...stationList.value.stations.map((v) => v.id), 0) + 1, //FIXME
          name:
            newStationName.value || String(stationList.value.stations.length),
          shouldRecordTime: true,
        })
      );
      newStationName.value = "";
    };
    const changeCheckbox = (stationListIndex: number) => {
      const newList: Station[] = stationList.value.stations.map((v, idx) => {
        return {
          id: v.id,
          name: v.name,
          shouldRecordTime:
            idx === stationListIndex ? !v.shouldRecordTime : v.shouldRecordTime,
        };
      });
      store.dispatch("updateStationList", newList);
    };

    const isOpenStationNameChange = ref<boolean[]>([]);
    const changingStationName = ref("");
    const onChangeStationName = (e: { target: HTMLInputElement }) => {
      changingStationName.value = e.target.value;
    };
    const changeStationName = (stationListIndex: number) => {
      const newList: Station[] = stationList.value.stations.map((v, idx) => {
        return {
          id: v.id,
          name:
            idx === stationListIndex
              ? changingStationName.value || v.name || String(idx)
              : v.name,
          shouldRecordTime: v.shouldRecordTime,
        };
      });
      store.dispatch("updateStationList", newList);
      isOpenStationNameChange.value[stationListIndex] = false;
    };

    const onEnter = (keyCode: number, cb: () => void) => {
      if (keyCode === 13) cb();
    };

    return {
      stationList,
      newStationName,
      addStation,
      onEnter,
      changeCheckbox,
      isOpenStationNameChange,
      changeStationName,
      onChangeStationName,
    };
  },
});
